import { FC, useCallback } from 'react';
import { Button } from 'components/Button';
import { useDataCollection } from 'modules/AnalyticsCollection/AnalyticsCollectionProvider';
import { ShareButtons } from 'modules/Playground/Components/ShareButtons';
import { InfoMessage } from 'modules/Playground/Components/HeaderMessages/InfoMessage';
import SvgRocket02Md from 'modules/Playground/Components/Icons/Rocket02Md';
import SvgDotsVerticalMd from 'modules/Playground/Components/Icons/DotsVerticalMd';
import { useFormikContext } from 'formik';
import { PlaygroundConfig } from 'modules/Playground/types/playgroundConfig';
import { generateDeployNewModelUrl } from 'modules/Compute/Components/ComputeEntitySelector/utils';
import { useRouter } from 'next/router';
import { useIsLoggedIn } from 'modules/Auth/hooks';
import { useAuthActions } from 'modules/Auth/AuthContext';
import { ModeSwitch } from 'modules/Playground/Components/ModeSwitch/ModeSwitch';
import { useAutoModeSwitch } from 'modules/Playground/Components/ModeSwitch/useAutoModeSwitch';
import { UniversalSearch } from 'components/UniversalSearch/UniversalSearch';
import { useFeatureFlagsLD } from 'modules/FeatureFlagsLD/FeatureFlagsProviderLD';
import { PlaygroundModelSelector } from 'modules/Playground/Components/PlaygroundModelSelector/PlaygroundModelSelector';
import { useCompareMode } from 'modules/Playground/hooks/utils/useCompareMode';
import { closeButton, optionsButton, playgroundHeaderContainer, playgroundLeftHeader, playgroundRightHeader, playgroundSelectorWrapper } from 'modules/Playground/Components/PlaygroundHeader.styled';
import { IconClose } from 'components/Icons/IconClose';
import IconCompare from './Icons/IconCompare';
const SHOW_ACTIONS_BUTTON = false;
interface PlaygroundHeaderProps {
  onCompareModeToggle?: () => void;
}
export const PlaygroundHeader: FC<PlaygroundHeaderProps> = ({
  onCompareModeToggle
}) => {
  const router = useRouter();
  const {
    track
  } = useDataCollection();
  const {
    values
  } = useFormikContext<PlaygroundConfig>();
  const isLoggedIn = useIsLoggedIn();
  const {
    openLoginModal
  } = useAuthActions();
  const {
    universalSearchLDFF
  } = useFeatureFlagsLD();
  const {
    isCompareMode,
    onCompareModeToggle: toggleCompareMode
  } = useCompareMode();
  const appId = values.model?.app_id;
  const modelId = values.model?.id;
  const modelVersionId = values.modelVersion?.id;
  const userId = values.model?.user_id;
  const redirectToCompute = useCallback(() => {
    track('Playground -> Deploy Clicked');
    if (!isLoggedIn) {
      openLoginModal();
      return;
    }
    router.push(generateDeployNewModelUrl({
      appId,
      modelId,
      modelVersionId,
      userId
    }));
  }, [isLoggedIn, modelId, modelVersionId]);
  const handleCompareModeToggle = useCallback(() => {
    track('Playground -> Compare Mode Toggled', {
      isCompareMode: !isCompareMode
    });
    toggleCompareMode();
    onCompareModeToggle?.();
  }, [isCompareMode, onCompareModeToggle, track, toggleCompareMode]);
  useAutoModeSwitch();
  return <div className={playgroundHeaderContainer}>
      <div className={playgroundLeftHeader}>
        {!isCompareMode && <ModeSwitch />}
        <div className={playgroundSelectorWrapper}>{universalSearchLDFF ? <UniversalSearch /> : <PlaygroundModelSelector />}</div>
        <ShareButtons />
        {isCompareMode && <Button variant="primary" size="md" LeftIcon={SvgRocket02Md} onClick={redirectToCompute}>
            Deploy
          </Button>}
      </div>
      <div className={playgroundRightHeader}>
        {!isCompareMode && <>
            <InfoMessage />
            <Button variant="tertiary" size="md" LeftIcon={IconCompare} onClick={handleCompareModeToggle}>
              Compare Models
            </Button>
          </>}
        {!isCompareMode && <Button variant="primary" size="md" LeftIcon={SvgRocket02Md} onClick={redirectToCompute}>
            Deploy
          </Button>}

        {SHOW_ACTIONS_BUTTON && <Button className={optionsButton} variant="tertiary" size="md" LeftIcon={SvgDotsVerticalMd} />}
        {isCompareMode && onCompareModeToggle && <Button className={closeButton} variant="tertiary" size="md" RightIcon={IconClose} iconSize={20} onClick={handleCompareModeToggle} />}
      </div>
    </div>;
};